module.exports = "<vb-content-page-view\r\n  [actions]=\"actions\">\r\n\r\n  <h1 page-title>Lager bestücken</h1>\r\n\r\n  <div page-content>\r\n\r\n    <vb-sub-admin-unit-needs>\r\n\r\n    </vb-sub-admin-unit-needs>\r\n\r\n  </div>\r\n\r\n</vb-content-page-view>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/store-management/procurement/views/fill-up-depot-view/fill-up-depot-view.component.html
// module id = ./src/app/store-management/procurement/views/fill-up-depot-view/fill-up-depot-view.component.html
// module chunks = main